import React, {Fragment} from 'react';

export default function(){
    return(
        <Fragment>
            <h1>DNA Methylation</h1>
            <p>
               
            </p>
            <p>
              
            </p>
        </Fragment>
    )
}